module.exports = __webpack_public_path__ + "static/img/45_cherry.1689fecb.jpg";